import { Theme } from '@mui/material/styles'

export const styles = {
  sectionHeader: {
    fontSize: '16px',
    fontFamily: 'Source Sans Pro Semibold',
  },
  templateDropdown: { maxHeight: '500px' },
}

export interface Props {
  tidalThemeActive?: boolean
}

export const getDrawerStyles = (theme: Theme, props: Props) => ({
  modal: { zIndex: theme.zIndex.modal },
  drawer: {
    display: 'block',
    width: 550,
    overflow: 'auto',
  },
  header: {
    display: 'flex',
    padding: `${theme.spacing(1.3)} ${theme.spacing(2)}`,
    flexWrap: 'nowrap',
  },
  header1: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    padding: `${theme.spacing(1.3)} ${theme.spacing(2)}`,
    textTransform: 'capitalize',
    fontFamily: 'Source Sans Pro Bold',
    /*  height: props.tidalThemeActive ? '56px' : '74px', */
    borderBottom: props.tidalThemeActive
      ? 'none'
      : `1px solid ${theme.palette.divider}`,
  },
  headerWithoutBack: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    padding: `${theme.spacing(1.1)} ${theme.spacing(2)}`,
    fontFamily: 'Source Sans Pro Bold',
    height: props.tidalThemeActive ? '56px' : '74px',
  },
  close: {
    minWidth: 'unset',
    marginLeft: 'auto',
  },
  hideRoot: { margin: theme.spacing(0), marginLeft: 'auto' },
  hideRootAdj: {
    margin: theme.spacing(0),
    marginLeft: 'auto',
    marginTop: theme.spacing(-0),
  },
  hideLabel: { fontSize: '14px' },
})
